export default "__VITE_ASSET__DEFLB0Pg__"